module.exports = __webpack_public_path__ + "static/media/trimex_sacoF.8ce0a587.png";